(function() {
    'use strict';

    angular
        .module('receiptApp')
        .controller('ContestPaymentController', ContestPaymentController);

    ContestPaymentController.$inject = ['$scope', '$state', 'ReceiptService', 'CONST_RECEIPT', 'AlertService', '$window', 'authExpiredInterceptor'];

    function ContestPaymentController ($scope,  $state, ReceiptService, CONST_RECEIPT, AlertService, $window, authExpiredInterceptor) {
    	var contestPaymentCtr = this;
    	var self = $scope;
    	var receiptScope = self.$parent.$parent;
    	receiptScope.title = 'CHI THƯỞNG CONTEST 1';
    	contestPaymentCtr.init = function() {
    		if(receiptScope.contestPayment != null) {
    			contestPaymentCtr.isDisable = false;
    			self.entity = receiptScope.contestPayment;
        		self.entity.receiverType = '1';
        		self.agentCode = self.entity.receiverCode;
        		self.agentName = self.entity.receiverName;
        		contestPaymentCtr.receiptNum = receiptScope.receiptNum;
        		
    		}
        };
        
        contestPaymentCtr.init();
    	
    	contestPaymentCtr.save = function(){
    		receiptScope.loading = true;
    		ReceiptService.save({uri:"save-contest"}, self.entity, function(data){
    			receiptScope.loading = false;
    			self.entity = data;
    			contestPaymentCtr.isDisable = true;
        		$window.open(GLOBAL_URL + 'api/ga/receipt/print-contest-payment-cash-ga/'+ data.txnId + '?access_token=' + authExpiredInterceptor.getToken(),'_blank');
    		},function(error) {
    			receiptScope.loading = false;
    		});    		
    	}
    	
    	contestPaymentCtr.reset = function() {
    		transitionToState();
        };
        contestPaymentCtr.cancel = function() {
        	self.addAlert('Không chi thưởng cho giao dịch [' + self.entity.txnId + ']này.','success');
    		transitionToState();
        };
        function transitionToState () {
        	if(CONST_RECEIPT.TRANSACTION_TYPE_PROPOSAL == receiptScope.receipt.transaction.txnType) {
    			if(CONST_RECEIPT.CUSTOMER_TYPE_INDIVIDUAL == receiptScope.receipt.proposal.customer.customerType) {
    				$state.transitionTo(CONST_RECEIPT.STATE_INDIVIDUAL, {}, { 
    	    			  reload: true, inherit: false, notify: true
    	    			});
    			}else {
    				$state.transitionTo(CONST_RECEIPT.STATE_CORPORATION, {}, { 
  	    			  reload: true, inherit: false, notify: true
  	    			});
    			}
    		}else {
    			$state.transitionTo(CONST_RECEIPT.STATE_POLICY, {}, { 
      			  reload: true, inherit: false, notify: true
      			});
    		}
        }
        contestPaymentCtr.changeType = function(type) {
        	if(type == '1'){
        		self.entity.receiverCode = self.agentCode;
            	self.entity.receiverName = self.agentName;
        	} else {
        		self.entity.receiverCode = null;
            	self.entity.receiverName = null;
        	}
        	
        		
        }
    }
})();
